import { render, staticRenderFns } from "./AdjustList.vue?vue&type=template&id=0c59c5cb"
import script from "./AdjustList.vue?vue&type=script&lang=js"
export * from "./AdjustList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports